import actions from '../actions/error';

export default {
	namespaced: true,
	state: {
		error: '',
	},
	mutations: {
		[actions.SET_ERROR]: (state, error) => {
			state.error = error;
		},
		[actions.REMOVE_ERROR]: (state) => {
			state.error = '';
		},
	},
	actions: {
		[actions.SET_ERROR]: ({ commit }, error) => {
			commit(actions.SET_ERROR, error);
		},
		[actions.REMOVE_ERROR]: ({ commit }) => {
			commit(actions.REMOVE_ERROR);
		},
	},
	getters: {
		HasError: state => !!state.error,
		Message: state => state.error,
	},
};
